import { SidebarTrigger } from "@/components/sidebar";
import { H1 } from "@/components/typography";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "./breadcrumb";
import { NotificationBell } from "./notification-bell";

export type PageCategory = "team" | "clients" | "product";

interface PageHeaderProps {
  title: string;
  description?: string;
  category: PageCategory;
  parent?: {
    title: string;
    path: string;
  };
  showTitle?: boolean;
}

const categoryLabels: Record<PageCategory, string> = {
  team: "Team",
  clients: "Clients",
  product: "Product",
};

export function PageHeader({ title, description, category, parent, showTitle = true }: PageHeaderProps) {
  const categoryLabel = categoryLabels[category];

  return (
    <>
      <div className="sticky top-0 z-10 bg-background border-b">
        <div className="flex items-center gap-2 px-8 py-4">
          <SidebarTrigger />
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbPage className="text-muted-foreground">{categoryLabel}</BreadcrumbPage>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              {parent && (
                <>
                  <BreadcrumbItem>
                    <BreadcrumbLink asChild>
                      <Link to={parent.path}>{parent.title}</Link>
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator />
                </>
              )}
              <BreadcrumbItem>
                <BreadcrumbPage>{title}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
          <div className="ml-auto">
            <NotificationBell />
          </div>
        </div>
      </div>
      {showTitle && (
        <div className="px-8 pt-6 pb-4">
          <H1>{title}</H1>
          {description && <p className="text-muted-foreground">{description}</p>}
        </div>
      )}
    </>
  );
}
